import { atom } from 'jotai'
import { BannerItem } from '@/core/services/videoBanner.service'

export const videoBannersAtom = atom<BannerItem[]>([])

export const isLoadingVideoBannersAtom = atom<boolean>(false)

export const videoBannersErrorAtom = atom<string | null>(null)

export const hasLoadedVideoBannersAtom = atom<boolean>(false)

export const heroBannerAtom = atom<BannerItem | null>(get => {
    const banners = get(videoBannersAtom)
    return banners[0] ?? null
})

export const introduceBannerAtom = atom<BannerItem | null>(get => {
    const banners = get(videoBannersAtom)
    return banners[1] ?? null
})
